import { ArrowLeftRight, Layers, PackageCheck, ShieldCheck, ToggleRight, WifiOff } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Pillar = { Icon: LucideIcon; title: string; body: string };

const PILLARS: ReadonlyArray<Pillar> = [
  {
    Icon: Layers,
    title: 'Reprises multiples',
    body: 'Cumule plusieurs articles repris sur une même vente. Velko additionne les valeurs et calcule un seul appoint.',
  },
  {
    Icon: ArrowLeftRight,
    title: 'Rendu monnaie 2 sens',
    body: "Reprise inférieure au prix : le client complète. Reprise supérieure : tu rends la monnaie. Le sens est géré tout seul.",
  },
  {
    Icon: PackageCheck,
    title: 'Restock automatique',
    body: "L'article repris revient en stock immédiatement, prêt à la revente. Plus d'occasion oubliée dans un tiroir.",
  },
  {
    Icon: WifiOff,
    title: 'Hors ligne natif',
    body: 'La reprise fonctionne au comptoir sans réseau. Tout se synchronise dès que la connexion revient.',
  },
  {
    Icon: ToggleRight,
    title: 'Activable par boutique',
    body: 'Le troc est un module opt-in : tu l\'actives uniquement là où c\'est pertinent, sans alourdir les autres caisses.',
  },
  {
    Icon: ShieldCheck,
    title: 'Tout est tracé',
    body: 'Chaque reprise est enregistrée comme un mode de paiement : valeur, article, mouvement de stock. Ta caisse reste juste.',
  },
];

export default function TrocPillarsV2() {
  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">Ce qu'il y a dans la boîte</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.2vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-white">
          La reprise, <span className="text-lime-500">enfin propre.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-200">
          Pas un module à part qu'il faut relier — c'est ta caisse qui accepte les reprises, calcule
          l'appoint et tient le stock à jour.
        </p>

        <div className="mt-12 grid gap-[2px] border-2 border-charcoal-700 bg-charcoal-700 sm:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex min-h-[210px] flex-col gap-4 bg-charcoal-800 px-7 py-8 transition-colors duration-150 hover:bg-charcoal-900"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-lime-500 bg-charcoal-900 text-lime-500">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[20px] font-bold leading-[1.15] tracking-[-0.01em] text-white">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-200">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
